/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';
import { BlockingLoader } from '../../../../components/loader/BlockingLoader';
import './styles.scss';

interface AILoadingPlaceholderProps {
  isLoading?: boolean;
  isWriting: boolean;
  children: JSX.Element | JSX.Element[]
}

export const AILoadingPlaceholder = ({ isLoading = false, isWriting, children }: AILoadingPlaceholderProps) => {
  return (
    <>
      {isLoading ? <BlockingLoader /> : null}
      <div className={`w-100 text-left ${isWriting ? 'ai-glow' : ''}`}>
        {children}
      </div>
    </>
  );
}
